Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropDownCategories1266808962",
  {"root":"DropDownCategories1266808962--root","dropdown":"Dropdown3259921719--dropdown","title":"DropdownOption3584855492--title","arrowIcon":"DropdownBase3309326322--arrowIcon"},
  "",
  10,
  "DropDownCategories1266808962"
);

